import React from 'react'
import PropTypes from 'prop-types'
import mapTitles from '../mapTitles'

function BreadcrumbClinicalCares({ match }) {
  const titleParams = mapTitles(match.params.status)
  return <span>{titleParams.title}</span>
}

BreadcrumbClinicalCares.propTypes = {
  match: PropTypes.objectOf(Object).isRequired,
}

export default BreadcrumbClinicalCares
